import * as React from 'react';
import { Helmet } from 'react-helmet';

import EnterpriseGrowthExperiments from 'bundles/epic/clients/EnterpriseGrowth';

function MutinyTag() {
  const defaultExcludedRegion = EnterpriseGrowthExperiments.get('defaultExcludeMutiny') === true;
  // This will default exclude user sessions in the EU and EFTA regions for GDPR compliance.
  // Note: The position has importance for the {consentScript} below.
  const consentScript = defaultExcludedRegion ? <script>window.mutiny.client.defaultOptOut();</script> : undefined;

  return (
    <Helmet>
      <script>
        {`(function(){var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d})})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();`}
      </script>
      {consentScript}
      <script data-cfasync="false" src="https://client-registry.mutinycdn.com/personalize/client/b038efcc6b3aa65f.js" />
    </Helmet>
  );
}

export default MutinyTag;
